import InfoIcon from '@mui/icons-material/Info';
import { InputLabel, SelectChangeEvent, Stack, TextField, Tooltip } from '@mui/material';
import * as React from 'react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import variable from '../style/variable';
import { dialog } from '../util';

interface IInputTextProps {
    id?: string;
    name?: string;
    value?: any;
    disabled?: boolean;
    defaultValue?: unknown;
    required?: boolean;
    isNumber?: boolean;
    onChange?: any;
    minValue?: number;
    maxValue?: number;
    label?: string;
    textTooltip?: string | ReactNode;
    hidden?: boolean;
}

const Input = (props: IInputTextProps) => {
    const [inputValue, setInputValue] = React.useState(props.value ?? '');
    const { t } = useTranslation();

    let timer = React.useRef<NodeJS.Timeout | null>(null);

    React.useEffect(() => setInputValue(props.value), [props.value]);

    const handleInputChange = (e: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let r = e.target.value;
        let t = r.replace(/\,/g, '.');
        const isValidNumber = /^-?(([0-9]*)|(([0-9]*)\.([0-9]*)))$/gm.test(t) || /^[+-]?\d*(\.\d*)?([eE][+-]?\d*)?$/.test(t);
        if (isValidNumber) {
            handleInputRange(t, e);
            setValues(t, e);
        }
    };

    const handleInputRange = (value: string, e: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let minValue = props.minValue !== undefined && parseFloat(value) < props.minValue ? props.minValue : undefined;
        let maxValue = props.maxValue !== undefined && parseFloat(value) > props.maxValue ? props.maxValue : undefined;

        if (timer.current) {
            clearTimeout(timer.current);
        }
        if (minValue || maxValue) {
            timer.current = setTimeout(() => {
                if (minValue) {
                    value = minValue.toString();
                    showAlert(minValue, maxValue);
                }
                if (maxValue) {
                    value = maxValue.toString();
                    showAlert(minValue, maxValue);
                }
                setValues(value, e);
            }, 2500);
        }
    };

    const setValues = (value: string, e: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        setInputValue(value);
        e.target.value = value;
        props.onChange(e);
    };

    const showAlert = (min?: number, max?: number) => {
        if (min !== undefined && max !== undefined) dialog('warning', t('infoRangeValue', { min, max }));
        else if (min !== undefined) dialog('warning', t('infoMinValue', { min }));
        else if (max !== undefined) dialog('warning', t('infoMaxValue', { max }));
    };

    return (
        !props.hidden && (
            <Stack padding={'0.3rem 0rem'} spacing={0.5} flex={1}>
                {props.textTooltip ? (
                    <Stack direction={'row'} spacing={1} alignItems={'center'}>
                        <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                            {props.label}
                        </InputLabel>
                        <Tooltip title={props.textTooltip}>
                            <InfoIcon style={{ fill: variable.green, height:'18px' }} fontSize='small' />
                        </Tooltip>
                    </Stack>
                ) : (
                    <InputLabel required={props.required} style={{ fontSize: '0.8rem' }}>
                        {props.label}
                    </InputLabel>
                )}
                <TextField
                    id={props.id}
                    defaultValue={props.defaultValue}
                    name={props.name}
                    required={props.required}
                    value={props.isNumber ? inputValue : props.value}
                    disabled={props.disabled}
                    type='text'
                    onChange={props.isNumber ? handleInputChange : props.onChange}
                />
            </Stack>
        )
    );
};

export default Input;
